import { render } from "./ArriveForm.vue?vue&type=template&id=9e680204&scoped=true"
import script from "./ArriveForm.vue?vue&type=script&lang=js"
export * from "./ArriveForm.vue?vue&type=script&lang=js"

import "./ArriveForm.vue?vue&type=style&index=0&id=9e680204&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e680204"]])

export default __exports__